// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentPhoneNumberModel } from './extEnrollmentPhoneNumberModel.js';
import type { TCSCommunicationOption } from './tCSCommunicationOption.js';
import type { TCSCommunicationType } from './tCSCommunicationType.js';
import type { TCSSource } from './tCSSource.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentCreateSiteRequestModel {
    'siteVerified'?: boolean;
    'name'?: string;
    'phoneNumbers': Array<ExtEnrollmentPhoneNumberModel>;
    'address1'?: string;
    'address2'?: string;
    'city'?: string;
    'country'?: string;
    'state'?: string;
    'postalCode'?: string;
    'npi'?: string;
    'taxId'?: string;
    'communicationTypes': Array<TCSCommunicationType>;
    'communicationOption'?: TCSCommunicationOption;
    'sourceId'?: TCSSource;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentCreateSiteRequestModel>> = [
        {
            "name":     "siteVerified",
            "baseName": "siteVerified",
            "type":     "boolean"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<ExtEnrollmentPhoneNumberModel>"
        },
        {
            "name":     "address1",
            "baseName": "address1",
            "type":     "string"
        },
        {
            "name":     "address2",
            "baseName": "address2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "country",
            "baseName": "country",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "postalCode",
            "baseName": "postalCode",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "communicationTypes",
            "baseName": "communicationTypes",
            "type":     "Array<TCSCommunicationType>"
        },
        {
            "name":     "communicationOption",
            "baseName": "communicationOption",
            "type":     "TCSCommunicationOption"
        },
        {
            "name":     "sourceId",
            "baseName": "sourceId",
            "type":     "TCSSource"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentCreateSiteRequestModel.attributeTypeMap;
    }
}
